import type { FaireProductEntity } from "../../entity_types/product";

export const p_hnmdt9abm6: FaireProductEntity = {
  token: "p_hnmdt9abm6",
  type: "product",
  name: "Cuban Chain Colorful CZ Link Necklace Bracelet , Sku#EF349",
  brandToken: "b_4f46qpq5wu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/289a37ba625e185a7c964bc9a1df540d32ed9fedf429da34816685e91724d05c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6253587a5d56609bda34768eed0673dcd5b264af28c56859e146dcb527907d5.jpeg",
    "https://cdn.faire.com/fastly/24dc4a2efa6be6f8d539ef80641f50c98d979ee6287a49732a895dab8995dc12.jpeg",
    "https://cdn.faire.com/fastly/c114e13371f59df314af7603cdff1cc24d5c5827732efc07588ae71285ec29e4.jpeg",
    "https://cdn.faire.com/fastly/4e8728d43983c0f3c61b3b3a55bebb03d79200e424278f0089e0320db5121414.jpeg",
    "https://cdn.faire.com/fastly/dd8eaacfb602c23c411b5430570341d8e9037616e8468d81c8ce2144a92c03e5.jpeg",
    "https://cdn.faire.com/fastly/c42b6a1d29ce7f81f28b856946f13ea4b418389887bc0ffeae9a35e9b4bc2a46.jpeg",
  ],
  priceDollars: 18.11,
  description:
    "\nQty:1pc pack\nMaterial: Gold-filled CZ\n\n\nDescription:\n\n\nNecklace length: 16inch plus 2inch extension\n\nBracelet length: 7inch plus 2inch extension\n\nSilver: Rhodium Plated\nGold: 14K Gold Filled\nBlack: Palladium Plated\nRose Gold: Palladium Plated over Copper\nUsage: Gold Filled findings have a precious metal look. Ready to wear.\n--------------------------------------------------\nShip from the U.S.A in 1-2 business days.\n\n* Lead-Free & Cadmium Free & Nickel Free*\n\n*All sizes are approximate\n\n***Please Conv. me if you need quantity discount. \n\nM290-6MM; lx287; \n",
  tags: [],
  msrpDollars: 36.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:49.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
